import { useMemo } from "react";
import ReactCountryFlag from "react-country-flag";

import { Countries } from "../ChatPanel/helpers/CountriesModal.jsx/country";
import "./sliderCountries.scss";

export default function SliderCountries() {
  const countries = useMemo(() => Countries.countries || [], []);

  return (
    <div className="countriesSliderWrapper">
      <div className="countriesSliderWrapper__list">
        {countries.map((country, idx) => (
          <div
            key={`${country.id ?? country.shortName}-${idx}`}
            className="countriesSliderWrapper__list__item"
          >
            <ReactCountryFlag countryCode={country.shortName} svg />
            <span>{country.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
